import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=dafa7efe&lang=pug&"
import script from "./qr.vue?vue&type=script&setup=true&lang=js&"
export * from "./qr.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./qr.vue?vue&type=style&index=0&id=dafa7efe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports